import { createAppStore } from "./createStore";
import router from "@/router";

export default createAppStore({
	isShopApp: false,
	liffID: process.env.VUE_APP_liffID,
	baseUri: process.env.VUE_APP_baseUri,
	hostUrl: process.env.VUE_APP_hostUrl,
	migoBindLiffId: process.env.VUE_APP_migoBindLiffId,
	migoLiffId: process.env.VUE_APP_migoLiffId,
}, router);
